module.exports = __webpack_public_path__ + "img/part3bj.9d6eac20.png";